<template>
<div class="card card--transparent hide-sm fade-in landing-description small-top" style="width: 100%">
  <div >
    <h1 style="font-weight: 700">Welcome to the Ultimate Digital Coaching Platform</h1>
    <h4 style="font-weight: 500; padding-top: 10px">Working with a coach is the single most effective method for your personal and professional development.</h4>
    <ul class="small-top">
      <li>
        83% experience personal and professional growth
      </li>
      <li>
        3x more likely to have an excellent quality of life
      </li>
      <li>
        6x more likely to love your job
      </li>
    </ul>
    <div class="cta">
    <a v-if="link" class="small-top">Sign Up Today To Get Started</a>
    <h3 v-else class="small-top">Sign Up Today To Get Started</h3>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: ["link"]
};
</script>

<style lang="less" scoped>
a {
  font-size: 18px;
  font-weight: 500;
}
li {
  padding-top: 5px;
}
.cta {
  display: flex;
  flex-direction: column;
  align-self: center;
  align-content: center;
  justify-content: center;
}
</style>
